/**
 * @generated SignedSource<<a10eef0cb5986dd0274608a6d4f66733>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNotificationInput = {
  clientMutationId?: string | null;
  notificationId: string;
};
export type NotificationTableDataRow_Mutation$variables = {
  input: DeleteNotificationInput;
  connections: ReadonlyArray<string>;
};
export type NotificationTableDataRow_MutationVariables = NotificationTableDataRow_Mutation$variables;
export type NotificationTableDataRow_Mutation$data = {
  readonly deleteNotification: {
    readonly deletedNotificationId: string;
  } | null;
};
export type NotificationTableDataRow_MutationResponse = NotificationTableDataRow_Mutation$data;
export type NotificationTableDataRow_Mutation = {
  variables: NotificationTableDataRow_MutationVariables;
  response: NotificationTableDataRow_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedNotificationId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationTableDataRow_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteNotificationPayload",
        "kind": "LinkedField",
        "name": "deleteNotification",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NotificationTableDataRow_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteNotificationPayload",
        "kind": "LinkedField",
        "name": "deleteNotification",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedNotificationId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "378fc39425b2695b2a7906b700344652",
    "id": null,
    "metadata": {},
    "name": "NotificationTableDataRow_Mutation",
    "operationKind": "mutation",
    "text": "mutation NotificationTableDataRow_Mutation(\n  $input: DeleteNotificationInput!\n) {\n  deleteNotification(input: $input) {\n    deletedNotificationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff35db505022c159b83c7b347a94d1b5";

export default node;
